import domainByEnv from '@utils/domainByEnv';
const mainDomain = (() => {
    if (process.env.ENV === 'prod') return '//www.liontravel.com/';
    return '//uwww.liontravel.com/';
})();

const defaultImg = `${domainByEnv()}/_webassets/lightspeed/subsitebundles/common/imgs/BBC/default-BBC.jpg`;

export default defaultImg;
export const defaultImg43 = `${domainByEnv()}/_webassets/lightspeed/subsitebundles/common/imgs/BBC/default-BBC.jpg`;

//${domainByEnv()}/_webassets/lightspeed/subsitebundles/common/imgs/BBC/default-BBC.jpg`;
